import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 795A2085-78E1-4721-BF6F-007B20CF92AF
 * name countertop
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/countertop.svg
 * tags
 * - Home Automation 
 */
export const CountertopIcon = createSvgIcon(<><path d="M18 10V7C18 5.34 16.66 4 15 4S12 5.34 12 7H14C14 6.45 14.45 6 15 6S16 6.45 16 7V10H8C9.1 10 10 9.1 10 8V4H4V8C4 9.1 4.9 10 6 10H2V12H4V20H20V12H22V10H18M13 18H11V12H13V18Z" /></>, 'CountertopIcon');
export default CountertopIcon